/* VIYAN "Most Loved" carousel.
   Auto-advances, wraps back to the first product without a visible jump
   (appended clones + seam reset), and pauses on hover, focus, touch,
   background tabs and when scrolled off screen. */
(function () {
  'use strict';

  var TRANSITION = '600ms cubic-bezier(0.22, 0.61, 0.36, 1)';
  var SWIPE_THRESHOLD = 40;

  var MOBILE_QUERY = '(max-width: 749px)';

  /* On phones the carousel is a native horizontal scroller with scroll-snap,
     the same way the theme's own "Shop by Model" slider works: iOS handles
     the swipe itself, so vertical page scroll and sideways swipes never fight.
     No clones and no autoplay here; the dots only follow the scroll position. */
  function initNative(root) {
    var viewport = root.querySelector('[data-carousel-viewport]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-slide]'));
    if (!viewport || slides.length < 2) return;

    root.dataset.viyanCarouselInit = '1';

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-dot]'));
    var dotsWrap = root.querySelector('[data-carousel-dots]');
    if (dotsWrap) dotsWrap.style.display = 'flex';

    function offsetFor(i) {
      return slides[i].offsetLeft - slides[0].offsetLeft;
    }

    function activeIndex() {
      var left = viewport.scrollLeft;
      if (left >= viewport.scrollWidth - viewport.clientWidth - 2) return slides.length - 1;
      var best = 0;
      for (var i = 1; i < slides.length; i++) {
        if (Math.abs(offsetFor(i) - left) < Math.abs(offsetFor(best) - left)) best = i;
      }
      return best;
    }

    var frame = null;
    function syncDots() {
      frame = null;
      var active = activeIndex();
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === active);
      });
    }

    viewport.addEventListener(
      'scroll',
      function () {
        if (!frame) frame = requestAnimationFrame(syncDots);
      },
      { passive: true }
    );

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        viewport.scrollTo({ left: offsetFor(i), behavior: 'smooth' });
      });
    });

    syncDots();
  }

  function initCarousel(root) {
    if (root.dataset.viyanCarouselInit === '1') return;
    if (window.matchMedia(MOBILE_QUERY).matches) {
      initNative(root);
      return;
    }

    var track = root.querySelector('[data-carousel-track]');
    var viewport = root.querySelector('[data-carousel-viewport]');
    if (!track || !viewport) return;

    var originals = Array.prototype.slice.call(track.querySelectorAll('[data-carousel-slide]'));
    var count = originals.length;
    if (count < 2) return;

    root.dataset.viyanCarouselInit = '1';

    var container = root.closest('.viyan-bestsellers') || root;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-dot]'));
    var prevButton = container.querySelector('[data-carousel-prev]');
    var nextButton = container.querySelector('[data-carousel-next]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var interval = parseInt(root.dataset.autoplay || '0', 10) * 1000;

    var index = 0;
    var animating = false;
    var timer = null;
    var pointerDown = false;
    var startX = 0;
    var hovered = false;
    var focused = false;
    var onScreen = true;
    var pageVisible = !document.hidden;

    /* --- clones ------------------------------------------------------ */

    function visibleColumns() {
      var value = parseFloat(getComputedStyle(container).getPropertyValue('--vb-cols'));
      return isNaN(value) ? 1 : Math.ceil(value);
    }

    var copies = Math.max(1, Math.ceil((visibleColumns() + 1) / count));
    for (var c = 0; c < copies; c++) {
      originals.forEach(function (slide) {
        var clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.dataset.carouselClone = '1';
        clone.querySelectorAll('a, button, input, select, textarea').forEach(function (node) {
          node.setAttribute('tabindex', '-1');
        });
        track.appendChild(clone);
      });
    }

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-carousel-slide]'));

    /* --- positioning -------------------------------------------------- */

    function offsetFor(target) {
      var slide = slides[target];
      if (!slide) return 0;
      return slide.offsetLeft - slides[0].offsetLeft;
    }

    function apply(target, animate) {
      track.style.transition = animate && !reduceMotion ? 'transform ' + TRANSITION : 'none';
      track.style.transform = 'translate3d(' + -offsetFor(target) + 'px, 0, 0)';
    }

    function syncDots() {
      var active = ((index % count) + count) % count;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === active);
      });
    }

    function goTo(target, animate) {
      index = target;
      apply(index, animate);
      syncDots();
    }

    function next() {
      if (animating) return;
      animating = true;
      goTo(index + 1, true);
      armSettle();
    }

    function previous() {
      if (animating) return;
      animating = true;
      if (index === 0) {
        // Jump to the matching clone on the right, then animate left from there.
        goTo(count, false);
        // Force a reflow so the browser does not collapse both transforms.
        void track.offsetWidth;
      }
      goTo(index - 1, true);
      armSettle();
    }

    var settleTimer = null;

    function settle() {
      clearTimeout(settleTimer);
      settleTimer = null;
      animating = false;
      if (index >= count) {
        goTo(index - count, false);
      }
    }

    track.addEventListener('transitionend', function (event) {
      if (event.target !== track || event.propertyName !== 'transform') return;
      settle();
    });

    /* transitionend never fires with reduced motion or in a background tab,
       so always arm a fallback that releases the lock. */
    function armSettle() {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, reduceMotion ? 0 : 800);
    }

    /* --- autoplay ----------------------------------------------------- */

    function canPlay() {
      return interval > 0 && !reduceMotion && !hovered && !focused && !pointerDown && onScreen && pageVisible;
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function play() {
      stop();
      if (!canPlay()) return;
      timer = setInterval(next, interval);
    }

    function restart() {
      stop();
      play();
    }

    /* --- controls ----------------------------------------------------- */

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        next();
        restart();
      });
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        previous();
        restart();
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        if (animating) return;
        var current = ((index % count) + count) % count;
        if (i === current) return;
        animating = true;
        goTo(i, true);
        armSettle();
        restart();
      });
    });

    root.addEventListener('mouseenter', function () {
      hovered = true;
      stop();
    });
    root.addEventListener('mouseleave', function () {
      hovered = false;
      play();
    });
    root.addEventListener('focusin', function () {
      focused = true;
      stop();
    });
    root.addEventListener('focusout', function () {
      focused = false;
      play();
    });

    viewport.addEventListener(
      'touchstart',
      function (event) {
        pointerDown = true;
        startX = event.touches[0].clientX;
        stop();
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchend',
      function (event) {
        if (!pointerDown) return;
        pointerDown = false;
        var delta = event.changedTouches[0].clientX - startX;
        if (Math.abs(delta) > SWIPE_THRESHOLD) {
          if (delta < 0) {
            next();
          } else {
            previous();
          }
        }
        play();
      },
      { passive: true }
    );

    document.addEventListener('visibilitychange', function () {
      pageVisible = !document.hidden;
      play();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          onScreen = entries[0].isIntersecting;
          play();
        },
        { threshold: 0.2 }
      ).observe(root);
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        apply(index, false);
      }, 150);
    });

    container.classList.add('is-ready');
    goTo(0, false);
    play();
  }

  function initAll() {
    document.querySelectorAll('[data-viyan-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
